import { render, staticRenderFns } from "./RecommendationLibraryPicker.vue?vue&type=template&id=3788807a&scoped=true&"
import script from "./RecommendationLibraryPicker.vue?vue&type=script&lang=js&"
export * from "./RecommendationLibraryPicker.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationLibraryPicker.vue?vue&type=style&index=0&id=3788807a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3788807a",
  null
  
)

export default component.exports